import React from 'react';
import PolicyLayout from './PolicyLayout';

const CancellationPolicyPage: React.FC = () => (
  <PolicyLayout title="Cancellation Policy" lastUpdated="August 1, 2026">
    <section>
      <h2>1. Order Cancellation by Customer</h2>
      <p>You may cancel your order under the following conditions:</p>
      <ul>
        <li>Orders can be cancelled within <strong>24 hours</strong> of placing them</li>
        <li>Cancellations are only accepted if the order has not yet been shipped</li>
        <li>Once the item is shipped, cancellation is not possible — please refer to our Return Policy</li>
      </ul>
    </section>

    <section>
      <h2>2. How to Cancel</h2>
      <ol>
        <li>Go to <strong>My Orders</strong> in your account</li>
        <li>Select the order you wish to cancel</li>
        <li>Click the <strong>Cancel Order</strong> button (visible for eligible orders)</li>
        <li>Confirm the cancellation</li>
      </ol>
      <p>Alternatively, email us at <strong><a href="mailto:sastadealpvt@gmail.com">sastadealpvt@gmail.com</a></strong> with your order number.</p>
    </section>

    <section>
      <h2>3. Refund on Cancellation</h2>
      <ul>
        <li><strong>Prepaid orders:</strong> Full refund to original payment method within 5–7 business days</li>
        <li><strong>Wallet payments:</strong> Refund credited to your Sasta Fashions wallet within 24 hours</li>
        <li><strong>Cash on Delivery orders:</strong> No payment collected, so no refund applicable</li>
      </ul>
    </section>

    <section>
      <h2>4. Cancellation by Sasta Fashions</h2>
      <p>We reserve the right to cancel orders in the following cases:</p>
      <ul>
        <li>Item is out of stock or no longer available</li>
        <li>Payment verification failure</li>
        <li>Incomplete or incorrect delivery address</li>
        <li>Suspected fraudulent activity</li>
      </ul>
      <p>In such cases, a full refund will be processed immediately.</p>
    </section>

    <section>
      <h2>5. Contact</h2>
      <p>
        <strong>SASTA DEAL PRIVATE LIMITED</strong><br />
        Floor No. Gr - Fr, Building No. 114/K,<br />
        Raja S.C. Mullick Road, Near Naktala, Garia,<br />
        Kolkata, West Bengal – 700047<br />
        Email: <strong><a href="mailto:sastadealpvt@gmail.com">sastadealpvt@gmail.com</a></strong>
      </p>
    </section>
  </PolicyLayout>
);

export default CancellationPolicyPage;
